import loadable from '@loadable/component';
import FullPageLoader from '../../../components/UIElements/Loader/fullPageLoader';
export const ViewUserProfile = loadable(() => import('./ViewProfile/index'), {
  fallback: <FullPageLoader />,
});
export const ProfileSideBar = loadable(() => import('./ProfileSideBar/index'), {
  fallback: <FullPageLoader />,
});
